import React from 'react';
import divider from '../../assets/divider-img.png';
import s1 from '../../assets/strategy-icons/Group.png';
import s2 from '../../assets/strategy-icons/Group-1.png';
import s3 from '../../assets/strategy-icons/Layer1.png';
import s4 from '../../assets/strategy-icons/Layer2.png';

const BacktestStrategy = () => {
  return (
    <div className="backtest-component">
      <div className="container">
        <div className="backtest-main-wrapper">
          <div className="backtest-heading-description align-c-768">
            <h2>Strategy Development Expertise</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Our team possesses deep expertise in developing robust trading
              strategies. We combine quantitative analysis with market insights
              to design strategies that can navigate various market conditions
            </p>
          </div>
          <div className="backtest-content">
            <div className="backtest-content-inner">
              <div className="backtest-inner-items">
                <div className="backtest-inner-item">
                  <div className="strategy-icons">
                    <img src={s1} alt="strategy icon" />
                  </div>
                  <div className="strategy-textual">
                    <h4>Objective and Risk Profile</h4>
                    <p>
                      Every trader has unique objectives and risk tolerance. We
                      work closely with our clients to define clear trading
                      goals that align with their risk appetite.
                    </p>
                  </div>
                </div>
                <div className="backtest-inner-item">
                  <div className="strategy-icons">
                    <img src={s3} alt="strategy icon" />
                  </div>
                  <div className="strategy-textual">
                    <h4>Entry and Exit Criteria</h4>
                    <p>
                      A successful trading strategy requires well-defined entry
                      and exit criteria. We help traders establish these
                      criteria based on technical and fundamental indicators.
                    </p>
                  </div>
                </div>
              </div>
              <div className="backtest-inner-items mb-minus">
                <div className="backtest-inner-item">
                  <div className="strategy-icons">
                    <img src={s2} alt="strategy icon" />
                  </div>
                  <div className="strategy-textual">
                    <h4>Market Analysis</h4>
                    <p>
                      Our team conducts thorough market analysis to identify
                      potential opportunities and threats. This analysis informs
                      the design of our trading strategies.
                    </p>
                  </div>
                </div>
                <div className="backtest-inner-item">
                  <div className="strategy-icons">
                    <img src={s4} alt="strategy icon" />
                  </div>
                  <div className="strategy-textual">
                    <h4>Risk Management</h4>
                    <p>
                      Risk management is at the heart of every strategy we
                      develop. We implement safeguards to protect capital and
                      ensure that losses are kept to a minimum.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BacktestStrategy;
